// components/layouts/SplitViewLayout.jsx
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useKeyboard } from '../../hooks/useKeyboard'
import { cn } from '../../lib/cn'

export function SplitViewLayout({
  listComponent: ListComponent,
  detailComponent: DetailComponent,
  emptyState,
  basePath = '',
  detailProps = {},
}) {
  const { id } = useParams()
  const navigate = useNavigate()
  const [selectedId, setSelectedId] = useState(id)
  const [isMobile, setIsMobile] = useState(false)

  // Detect mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768)
    }
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  // Sync avec URL
  useEffect(() => {
    if (id) {
      setSelectedId(id)
    }
  }, [id])

  function handleSelect(newId) {
    setSelectedId(newId)
    if (basePath) {
      navigate(`${basePath}/${newId}`)
    }
  }

  function handleClose() {
    setSelectedId(null)
    if (basePath) {
      navigate(basePath)
    }
  }

  // Keyboard navigation (Desktop only)
  useKeyboard(
    {
      Escape: () => {
        if (!isMobile && selectedId) {
          handleClose()
        }
      },
    },
    [selectedId, isMobile]
  )

  // Mobile: full-screen detail
  if (isMobile && selectedId) {
    return (
      <div className="h-full">
        <DetailComponent id={selectedId} onClose={handleClose} {...detailProps} />
      </div>
    )
  }

  return (
    <div className="flex h-full overflow-hidden">
      {/* Liste (40% desktop, 100% mobile) */}
      <div
        className={cn(
          'overflow-y-auto border-r border-slate-200',
          isMobile ? 'w-full' : 'w-2/5'
        )}
      >
        <ListComponent
          selectedId={selectedId}
          onSelect={handleSelect}
        />
      </div>

      {/* Détail (60% desktop, hidden mobile) */}
      {!isMobile && (
        <div className="flex-1 overflow-y-auto bg-slate-50">
          {selectedId ? (
            <DetailComponent id={selectedId} onClose={handleClose} {...detailProps} />
          ) : (
            <div className="flex items-center justify-center h-full p-6">
              {emptyState || (
                <div className="text-center text-slate-500">
                  <div className="text-4xl mb-4">👈</div>
                  <div className="font-semibold">Sélectionnez un élément</div>
                  <div className="text-sm mt-1">Cliquez sur un élément de la liste</div>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  )
}
